var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { diffComparisonValueFormat } from '@workalizer/shared/types';
import { getPercentageDiff } from '@workalizer/shared/utils';
var sanitizeMeeting = function (meeting) { return (__assign(__assign({}, meeting), { durationSeconds: Number.isFinite(meeting.durationSeconds)
        ? meeting.durationSeconds
        : 0 })); };
export var normalizeMeetingAttendanceByDurationData = function (data) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q;
    var totals = data.totals;
    return {
        periods: ((_a = data.periods) !== null && _a !== void 0 ? _a : []).map(function (period) {
            var _a;
            return ({
                period: period.period,
                meetings: ((_a = period.meetings) !== null && _a !== void 0 ? _a : []).map(sanitizeMeeting)
            });
        }),
        prevPeriods: ((_b = data.prevPeriods) !== null && _b !== void 0 ? _b : []).map(function (period) {
            var _a;
            return ({
                period: period.period,
                meetings: ((_a = period.meetings) !== null && _a !== void 0 ? _a : []).map(sanitizeMeeting)
            });
        }),
        totals: {
            attendedCount: (_c = totals.attendedCount) !== null && _c !== void 0 ? _c : 0,
            attendedDuration: (_d = totals.attendedDuration) !== null && _d !== void 0 ? _d : 0,
            missedCount: (_f = (_e = totals.missedCount) !== null && _e !== void 0 ? _e : totals.skippedCount) !== null && _f !== void 0 ? _f : 0,
            missedDuration: (_h = (_g = totals.missedDuration) !== null && _g !== void 0 ? _g : totals.skippedDuration) !== null && _h !== void 0 ? _h : 0,
            attendedDurationPrevPeriodDiff: (_j = totals.attendedDurationPrevPeriodDiff) !== null && _j !== void 0 ? _j : getPercentageDiff(0, (_k = totals.attendedDuration) !== null && _k !== void 0 ? _k : 0, {
                comparisonValueFormat: diffComparisonValueFormat.durationSeconds
            }),
            missedDurationPrevPeriodDiff: (_l = totals.missedDurationPrevPeriodDiff) !== null && _l !== void 0 ? _l : getPercentageDiff(0, (_o = (_m = totals.missedDuration) !== null && _m !== void 0 ? _m : totals.skippedDuration) !== null && _o !== void 0 ? _o : 0, {
                comparisonValueFormat: diffComparisonValueFormat.durationSeconds
            }),
            attendedDurationTeamAvgDiff: (_p = totals.attendedDurationTeamAvgDiff) !== null && _p !== void 0 ? _p : null,
            missedDurationTeamAvgDiff: (_q = totals.missedDurationTeamAvgDiff) !== null && _q !== void 0 ? _q : null
        },
        teamPeriods: data.teamPeriods
    };
};
